import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "antd/dist/reset.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./redux/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

Sentry.init({
  dsn: "https://77eca1466d8959d053310e1f16e7d655@o4509111369400320.ingest.de.sentry.io/4509344484163664",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  enabled: process.env.REACT_APP_NODE_ENV === "production",
  environment: process.env.REACT_APP_NODE_ENV,
  sendDefaultPii: true,
});

root.render(
  <Provider store={store}>
    <App />
    <ToastContainer />
  </Provider>
);
